import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutOwnerMini, PageListMini, PageSection } from '../index';

const CharityMini: FunctionComponent<CharityMini> = ({
  totalCount,
  charities,
}) => {
  const { t } = useTranslation('common', { useSuspense: false });

  if (totalCount === 1) {
    const [
      { url, logo, title, impactStatement, registrationNumber },
    ] = charities;
    return (
      <AboutOwnerMini
        ownerUrl={url}
        logo={logo}
        name={title}
        description={impactStatement}
        registrationNumber={registrationNumber}
      />
    );
  }

  return (
    <PageSection
      title={t('page.charitysMiniTitle')}
      className="jg-pages-aboutownermini"
      count={totalCount}
    >
      <PageListMini pages={charities} totalCount={totalCount} />
    </PageSection>
  );
};

interface CharityMini {
  totalCount: number;
  charities: {
    id: string;
    title: string;
    logo?: string;
    url: string;
    registrationNumber: string;
    impactStatement: string;
  }[];
}

export default CharityMini;
